import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'ml-list-dialog',
  template: `
    <div fxLayout="column" fxLayoutAlign="space-between">
      <div class="mat-title">{{ data.title | translate | titlecase }}</div>

      <mat-form-field class="full-width" *ngFor="let value of data.list">
        <mat-label>{{ 'annotation' | translate | titlecase }}</mat-label>
        <input matInput value="{{ value }}" disabled />
      </mat-form-field>

      <button mat-button (click)="onConfirm()">
        {{ 'confirm' | translate | uppercase }}
      </button>
    </div>
  `,
  styleUrls: ['./list-dialog.component.scss']
})
export class ListDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ListDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      list: string[];
    }
  ) {}

  onConfirm() {
    this.dialogRef.close();
  }
}
